(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("jquery"), require("knockout"), require("lodash"), require("moment"));
	else if(typeof define === 'function' && define.amd)
		define('api-access',["jquery", "knockout", "lodash", "moment"], factory);
	else if(typeof exports === 'object')
		exports["api-access"] = factory(require("jquery"), require("knockout"), require("lodash"), require("moment"));
	else
		root["api-access"] = factory(root["jquery"], root["knockout"], root["lodash"], root["moment"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_13__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function(require, exports, module) {
	    var ajaxHelper = __webpack_require__(1);
	    var auth = __webpack_require__(6);
	    var commerce = __webpack_require__(7);
	    var cors = __webpack_require__(8);
	    var extadmin = __webpack_require__(15);
	    var gotomeet = __webpack_require__(16);
	    var config = __webpack_require__(9);
	    var logging = __webpack_require__(17);
	    var meetings = __webpack_require__(18);
	    var numbers = __webpack_require__(20);
	    var user = __webpack_require__(12);
	    var webUrls = __webpack_require__(10);
	    var recordings = __webpack_require__(21);
	
	    module.exports = {
	        ajaxHelper: ajaxHelper,
	        auth: auth,
	        commerce: commerce,
	        cors: cors,
	        extadmin: extadmin,
	        gotomeet: gotomeet,
	        logging: logging,
	        meetings: meetings,
	        numbers: numbers,
	        user: user,
	        webUrls: webUrls,
	        configure: config.configure,
	        recordings: recordings
	    };
	
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*
	 * IE 8/9 Do not support CORS ajax requests. This module checks for CORS support, and proxies through our backend if
	 * it is not available.
	 *
	 * Additionally, this modules caches all GET requests for a short period of time, to avoid repeated API calls. Any other
	 * request(POST, PUT, DELETE etc) will clear the cache.
	 *
	 */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function(require, exports, module) {
	
	    var $ = __webpack_require__(2);
	    var http = __webpack_require__(3);
	    var _ = __webpack_require__(5);
	
	    var TIMEOUT = 180000;//3*60*1000
	    var cache = {};
	
	    function checkIfCached(url, headers, data) {
	        if (cache[url]) {
	            var requestTime = new Date().getTime();
	            var expired = cache[url].expirationTime < requestTime;
	
	            var headersMatch = _.isEqual(cache[url].headers, headers);
	
	            var dataMatch = _.isEqual(cache[url].data, data);
	
	            if (headersMatch && dataMatch && !expired) {
	                return true;
	            } else {
	                return false;
	            }
	        } else {
	            return false;
	        }
	    }
	
	    /*
	     * Check if a response for required url is already cached
	     *
	     * @param url
	     * @param headers
	     * @param data
	     * @returns {*} returns the cached repose or false if noting is found
	     */
	    function getFromCache(url, headers, data) {
	        if (checkIfCached(url, headers, data)) {
	            return cache[url].response;
	        } else {
	            return false;
	        }
	
	    }
	
	    /*
	     * Stores API call response in local cache
	     *
	     * @param url
	     * @param headers
	     * @param data
	     * @param response
	     */
	    function storeInCache(url, headers, data, response) {
	        cache[url] = {
	            response: response,
	            headers: headers,
	            data: data,
	            expirationTime: new Date().getTime() + TIMEOUT
	        };
	    }
	
	    /*
	     * Delete cached response
	     *
	     * @param url
	     * @param headers
	     * @param data
	     * @returns {boolean}
	     */
	    function removeFromCache(url, headers, data) {
	        if (checkIfCached(url, headers, data)) {
	            return delete cache[url];
	        } else {
	            return true;
	        }
	    }
	
	    function clearCache() {
	        cache = {}; //Clear cache
	        return true;
	    }
	
	    /*
	     * Proxy IE8-10 requests through our backend
	     *
	     * @param request
	     * @returns {*}
	     */
	    function proxyRequest(request) {
	        return http.post('/ajax', request);
	    }
	
	    /*
	     * @param request
	     * @returns {*}
	     */
	    function makeRequest(request) {
	        var isCorsSupported = XMLHttpRequest && 'withCredentials' in new XMLHttpRequest();
	        var response;
	
	        if (isCorsSupported) {
	            response = $.ajax(request);
	        } else {
	            response = proxyRequest(request);
	        }
	
	        return response;
	    }
	
	    /*
	     * Make an API request, Cache API GET response in local Cache, if it is not already there.
	     * Any other request(POST, PUT, DELETE, etc) will clear the cache
	     *
	     * @param request jQuery ajax request object
	     * @returns {*} promise
	     */
	    function processCall(request) {
	        var response;
	        var launchRequest = (_.has(request, 'url') && request.url.indexOf('launchUrl') > -1);
	
	        if (request.type === 'GET' && !launchRequest) { //Cache GET requests, ignore /launch requests
	            // due to numerous corner cases
	
	            response = getFromCache(request.url, request.headers, request.data);
	
	            if (response) { //Response is cached
	                return response;
	            } else {
	                response = makeRequest(request);
	                storeInCache(request.url, request.headers, request.data, response); //Cache the response
	
	                response
	                    .fail(function() { //Only keep successful requests
	                        removeFromCache(request.url, request.headers, request.data);
	                    });
	
	                return response;
	            }
	        } else {
	
	            clearCache();
	            return makeRequest(request);
	        }
	    }
	
	    exports.process = processCall;
	    exports.clearCache = clearCache;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 2 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * Durandal 2.1.0 Copyright (c) 2012 Blue Spire Consulting, Inc. All Rights Reserved.
	 * Available via the MIT license.
	 * see: http://durandaljs.com or https://github.com/BlueSpire/Durandal for details.
	 */
	/**
	 * Enables common http request scenarios.
	 * @module http
	 * @requires jquery
	 * @requires knockout
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2), __webpack_require__(4)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, ko) {
	    /**
	     * @class HTTPModule
	     * @static
	     */
	    return {
	        /**
	         * The name of the callback parameter to inject into jsonp requests by default.
	         * @property {string} callbackParam
	         * @default callback
	         */
	        callbackParam: 'callback',
	        /**
	         * Converts the data to JSON.
	         * @method toJSON
	         * @param {object} data The data to convert to JSON.
	         * @return {string} JSON.
	         */
	        toJSON: function(data) {
	            return ko.toJSON(data);
	        },
	        /**
	         * Makes an HTTP GET request.
	         * @method get
	         * @param {string} url The url to send the get request to.
	         * @param {object} [query] An optional key/value object to transform into query string parameters.
	         * @param {object} [headers] The data to add to the request header.  It will be converted to JSON. If the data contains Knockout observables, they will be converted into normal properties before serialization.
	         * @return {Promise} A promise of the get response data.
	         */
	        get: function (url, query, headers) {
	            return $.ajax(url, { data: query, headers: ko.toJS(headers) });
	        },
	        /**
	         * Makes an JSONP request.
	         * @method jsonp
	         * @param {string} url The url to send the get request to.
	         * @param {object} [query] An optional key/value object to transform into query string parameters.
	         * @param {string} [callbackParam] The name of the callback parameter the api expects (overrides the default callbackParam).
	         * @param {object} [headers] The data to add to the request header.  It will be converted to JSON. If the data contains Knockout observables, they will be converted into normal properties before serialization.
	         * @return {Promise} A promise of the response data.
	         */
	        jsonp: function (url, query, callbackParam, headers) {
	            if (url.indexOf('=?') == -1) {
	                callbackParam = callbackParam || this.callbackParam;
	
	                if (url.indexOf('?') == -1) {
	                    url += '?';
	                } else {
	                    url += '&';
	                }
	
	                url += callbackParam + '=?';
	            }
	
	            return $.ajax({
	                url: url,
	                dataType: 'jsonp',
	                data: query,
	                headers: ko.toJS(headers)
	            });
	        },
	        /**
	         * Makes an HTTP PUT request.
	         * @method put
	         * @param {string} url The url to send the put request to.
	         * @param {object} data The data to put. It will be converted to JSON. If the data contains Knockout observables, they will be converted into normal properties before serialization.
	         * @param {object} [headers] The data to add to the request header.  It will be converted to JSON. If the data contains Knockout observables, they will be converted into normal properties before serialization.
	         * @return {Promise} A promise of the response data.
	         */
	        put:function(url, data, headers) {
	            return $.ajax({
	                url: url,
	                data: this.toJSON(data),
	                type: 'PUT',
	                contentType: 'application/json',
	                dataType: 'json',
	                headers: ko.toJS(headers)
	            });
	        },
	        /**
	         * Makes an HTTP POST request.
	         * @method post
	         * @param {string} url The url to send the post request to.
	         * @param {object} data The data to post. It will be converted to JSON. If the data contains Knockout observables, they will be converted into normal properties before serialization.
	         * @param {object} [headers] The data to add to the request header.  It will be converted to JSON. If the data contains Knockout observables, they will be converted into normal properties before serialization.
	         * @return {Promise} A promise of the response data.
	         */
	        post: function (url, data, headers) {
	            return $.ajax({
	                url: url,
	                data: this.toJSON(data),
	                type: 'POST',
	                contentType: 'application/json',
	                dataType: 'json',
	                headers: ko.toJS(headers)
	            });
	        },
	        /**
	         * Makes an HTTP DELETE request.
	         * @method remove
	         * @param {string} url The url to send the delete request to.
	         * @param {object} [query] An optional key/value object to transform into query string parameters.
	         * @param {object} [headers] The data to add to the request header.  It will be converted to JSON. If the data contains Knockout observables, they will be converted into normal properties before serialization.
	         * @return {Promise} A promise of the get response data.
	         */
	        remove:function(url, query, headers) {
	            return $.ajax({
	                url: url,
	                data: query,
	                type: 'DELETE',
	                headers: ko.toJS(headers)
	            });
	        }
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 4 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_5__;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function(require, exports, module) {
	    var token;
	
	    module.exports = {
	        setToken: function (accessToken) {
	            token = accessToken;
	        },
	
	        getToken: function () {
	            if (!token) {
	                throw new Error('Attempted to get token without setting it first.');
	            }
	
	            return token;
	        }
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function(require, exports, module) {
	    var cors = __webpack_require__(8);
	    var user = __webpack_require__(12);
	    var $ = __webpack_require__(2);
	    var webUrls = __webpack_require__(10);
	
	    var commerce = {
	
	        getBilling: function() {
	            return user.me().then(function(meData) {
	                var channel = meData.channel;
	                if (channel && channel.toLowerCase() === 'online') {
	                    return cors.getSecure(webUrls.get('meetingSvcUrl') + '/rest/2/billing');
	                }
	                return $.Deferred().reject();
	            });
	        },
	
	        getProducts: function () {
	            return user.me().then(function(meData) {
	                var channel = meData.channel;
	                if (channel && channel.toLowerCase() === 'online') {
	                    return cors.getSecure(webUrls.get('meetingSvcUrl') + '/rest/2/products');
	                }
	                return $.Deferred().reject();
	            });
	        },
	
	        getCatalog: function (catalogKey, region) {
	            // catalogKey is required.  region is optional as meeting service
	            // can get region if it is ommitted.
	            return user.me().then(function(meData) {
	                var channel = meData.channel;
	                var queryString = catalogKey;
	
	                if (region) {
	                    queryString += '?region=' + region;
	                }
	
	                if (channel && channel.toLowerCase() === 'online') {
	                    return cors.getSecure(
	                        webUrls.get('meetingSvcUrl') +
	                            '/rest/2/catalogs/' +
	                            queryString
	                    );
	                }
	                return $.Deferred().reject();
	            });
	        }
	    };
	
	    module.exports = commerce;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*
	 * Abstraction layer to perform ajax requests using authorization header
	 * also includes functionality to obtain the header.
	 *
	 * @module cors
	 */
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function(require, exports, module) {
	    var _ = __webpack_require__(5);
	    var ko = __webpack_require__(4);
	    var auth = __webpack_require__(6);
	    var $ = __webpack_require__(2);
	    var ajaxHelper = __webpack_require__(1);
	    var config = __webpack_require__(9);
	    var self = this;
	    /*
	     * In case CORS methods are called with undefined arguments, any data sent
	     * should be set to null instead of undefined.
	     */
	    function toJSON(data) {
	        if (data) {
	            return ko.toJSON(data);
	        } else {
	            return null;
	        }
	    }
	
	    function isClientNameHeader(header) {
	        return header === 'X-ClientName' || header === 'Client-Name' || header === 'ClientName';
	    }
	
	    function endsWith(str, suffix) {
	        return str.indexOf(suffix, str.length - suffix.length) !== -1;
	    }
	
	    /*
	     * GET, POST, PUT, and DELETE calls wrappers
	     * Identical to Durandal's http plugin, except all calls are proxied through
	     * ajaxHelper for IE8-9 support(Since those browsers do not fully support CORS.
	     */
	    function makeRequest(method, url, headers, data, options) {
	        var heads = _.merge(headers || {}, config.config.headers || {});
	        var clientNameHeader = Object.getOwnPropertyNames(heads).filter(isClientNameHeader).reverse().pop() || 'ClientName';
	        var clientNameValue = heads[clientNameHeader] || 'unknown';
	        clientNameValue = endsWith(clientNameValue, '::api-access') ? clientNameValue : clientNameValue + '::api-access';
	        heads[clientNameHeader] = clientNameValue;
	        var ajaxRequest = {
	            url: url,
	            type: method,
	            headers: ko.toJS(heads),
	            dataType: 'json'
	        };
	        if (data) {
	            if (method === 'GET') {
	                ajaxRequest.data = data;
	            } else {
	                ajaxRequest.data = ko.toJSON(data);
	                ajaxRequest.contentType = 'application/json';
	            }
	        }
	        ajaxRequest = _.merge(ajaxRequest, options);
	
	
	        return ajaxHelper.process(ajaxRequest)
	            .fail(function (jqXHR) {
	              config.config.handleAjaxFailure(jqXHR, method.toLowerCase(), url);
	            });
	    }
	
	    function addTokenToHeaders (httpHeaders) {
	        var headers = _.assign({}, httpHeaders);
	        headers.Authorization = 'Bearer ' + auth.getToken();
	        return headers;
	    }
	
	    /////////////////////////////////////////////////////////////////////////////////////////
	    /// Secure GET, POST, PUT and DELETE calls
	    ///
	    /// Automatically maintains current user token and sets Authorization Header for secure API calls
	    ///
	    /// Make sure to use this abstraction for all Secure CORS requests, to insure cross browser support
	    /// For un-secure CORS requests, use the un-secure counterparts bellow.
	    /////////////////////////////////////////////////////////////////////////////////////////
	
	    /*
	     * Perform a get request using Authorization header with token
	     *
	     * @param url
	     * @param data
	     * @returns {*}
	     */
	    function getSecure(url, data, headers, options) {
	        return get(url, data, addTokenToHeaders(headers), options);
	    };
	
	    /*
	     * Perform a post request using Authorization header with token
	     *
	     * @param url
	     * @param data
	     * @returns {*}
	     */
	    function postSecure(url, data, headers, options) {
	        return post(url, data, addTokenToHeaders(headers), options);
	    };
	
	    /*
	     * Perform a put request using Authorization header with token
	     *
	     * @param url
	     * @param data
	     * @returns {*}
	     */
	    function putSecure(url, data, headers, options) {
	        return put(url, data, addTokenToHeaders(headers), options);
	    };
	
	    /*
	     * Perform a delete request using Authorization header with
	     * delegation token if ending meeting, otherwise user token
	     *
	     * @param url
	     * @param delegationToken (optional)
	     * @returns {*}
	     *
	     * Note: Had to use del instead of delete, since delete is a reserved keyword in IE8
	     */
	    function delSecure(url, headers, options) {
	        return del(url, addTokenToHeaders(headers), options);
	    };
	
	    /////////////////////////////////////////////////////////////////////////////////////////
	    /// Regular GET, POST, PUT and DELETE calls
	    ///
	    /// Make sure to use this abstraction for all Un-secure CORS requests, to insure cross browser support
	    /// For secure CORS requests, use the secure counterparts above.
	    /////////////////////////////////////////////////////////////////////////////////////////
	
	    /*
	     * Perform a GET request
	     * @param url
	     * @param data
	     * @returns {*}
	     */
	    function get(url, data, headers, options) {
	        return makeRequest('GET', url, headers, data, options);
	    };
	
	    /*
	     * Perform a POST request
	     *
	     * @param url
	     * @param data
	     * @returns {*}
	     */
	    function post(url, data, headers, options) {
	        return makeRequest('POST', url, headers, data, options);
	    };
	
	    /*
	     * Perform a PUT request
	     *
	     * @param url
	     * @param data
	     * @returns {*}
	     */
	    function put(url, data, headers, options) {
	        return makeRequest('PUT', url, headers, data, options);
	    };
	
	    /*
	     * Perform a DELETE request
	     *
	     * @param url
	     * @returns {*}
	     *
	     * Note: Had to use del instead of delete, since delete is a reserved keyword in IE8
	     */
	    function del(url, headers, options) {
	        return makeRequest('DELETE', url, headers, null, options);
	    };
	
	    function clearCache() {
	        return ajaxHelper.clearCache();
	    };
	
	    module.exports = {
	        get: get,
	        post: post,
	        put: put,
	        del: del,
	        getSecure: getSecure,
	        postSecure: postSecure,
	        putSecure: putSecure,
	        delSecure: delSecure,
	        clearCache: clearCache
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function(require, exports, module) {
	    var webUrls = __webpack_require__(10);
	    var language = __webpack_require__(11);
	    var auth = __webpack_require__(6);
	    var _ = __webpack_require__(5);
	
	    var config = {
	        locale: 'en',
	        handleAjaxFailure: function () {}
	    };
	
	    module.exports = {
	        configure: function (configuration) {
	            config = _.merge(config, configuration);
	            webUrls.setWebUrls(config.urls);
	            language.set(config.locale);
	            auth.setToken(config.token);
	        },
	
	        config: config
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function(require, exports) {
		var self = this;
	    self.webUrls = {};
	
	    exports.setWebUrls = function(webUrls) {
	        self.webUrls = webUrls;
	    };
	
	    exports.get = function(key) {
	    	return self.webUrls[key];
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function(require, exports) {
		var self = this;
	    self.language = '';
	
	    exports.set= function(language) {
	        self.language = language;
	    };
	
	    exports.get = function() {
	    	return self.language;
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function(require, exports, module) {
	    var _ = __webpack_require__(5);
	    var cors = __webpack_require__(8);
	    var moment = __webpack_require__(13);
	    var availableCountriesFilter = __webpack_require__(14);
	    var webUrls = __webpack_require__(10);
	    var language = __webpack_require__(11);
	    var $ = __webpack_require__(2);
	
	    // makes sure we don't have dis-allowed countries in the
	    // default countries arrays, this case can happen, when
	    // a user has country A selected as default, and then the admin
	    // removes country A from the allowed countries list
	    var ensureConsistency = function (settings) {
	        if (!settings.audio) {
	            return settings;
	        }
	
	        var audio = settings.audio;
	
	        audio.defaultTollCountries = availableCountriesFilter(audio.allowedTollCountries,
	            audio.defaultTollCountries);
	
	        audio.defaultTollFreeCountries = availableCountriesFilter(audio.allowedTollFreeCountries,
	            audio.defaultTollFreeCountries);
	
	        var index;
	        var hashKeys = function (arr) {
	            var hash = {};
	            arr.forEach(function (el) { hash[el] = true; });
	            return hash;
	        };
	
	        var existsInHash = function (hash) {
	            return function filter(el, index) { return hash[el.country]; };
	        };
	
	        if (audio.defaultTollCountriesNamed) {
	            index = hashKeys(audio.allowedTollCountries);
	            audio.defaultTollCountriesNamed = audio.defaultTollCountriesNamed.filter(existsInHash(index));
	        }
	
	        if (audio.defaultTollFreeCountriesNamed) {
	            index = hashKeys(audio.allowedTollFreeCountries);
	            audio.defaultTollFreeCountriesNamed = audio.defaultTollFreeCountriesNamed.filter(existsInHash(index));
	        }
	
	        // we need to resolve with all the arguments that were passed in
	        // otherwise bad things happen when people use $.when().then()
	        // (ie. then fn receives a single parameter instead of an array)
	        // resolving with 'arguments' is fine, since we are modifing the references inside only
	        var prom = $.Deferred();
	        return prom.resolve.apply(prom, arguments);
	    };
	
	    var user = {
	
	        /**
	         * Get current user info
	         */
	        me: function(headers, options) {
	            return cors.getSecure(webUrls.get('meetingSvcUrl') + '/rest/me', null, headers, options);
	        },
	
	        product: function(headers, options) {
	            return user.me().then(function(meData) {
	                var channel = meData.channel;
	                if (channel && channel.toLowerCase() === 'online') {
	                    var promise = $.Deferred();
	
	                    var loadProduct = function () {
	                        return cors
	                            .getSecure(webUrls.get('meetingSvcUrl') + '/rest/2/product', null, headers, options)
	                            .fail(function () {
	                                return [{}];
	                            });
	                    };
	
	                    // make the call to products and resolve the promise even if the call fails
	                    // it may mean that the user does not have any products (ie corporate users)
	                    // but we don't want to break in that case... we may want to implement more
	                    // granular control of what we return, but for now return an empty object
	                    loadProduct()
	                        .then(promise.resolve)
	                        .fail(function () {
	                            promise.resolve([{}]);
	                        });
	
	                    return promise.promise();
	                } else {
	                    return $.Deferred().reject();
	                }
	            });
	        },
	
	        bundles: function(headers, options) {
	            return cors.getSecure(webUrls.get('meetingSvcUrl') + '/rest/2/bundles', null, headers, options);
	        },
	
	        /**
	         * Get Organizer Settings
	         * Get Organizer Settings API returns the settings, the organizer has, for the G2M product
	         */
	        settings: function(headers, options) {
	            // load the settings and pass them through a consitency check fn
	            var locale = language.get() ? language.get().replace('-', '_') : 'en'; // API expects underscores instead of dashes
	            return cors.getSecure(webUrls.get('meetingSvcUrl') + '/rest/2/settings?locale=' + locale, null, headers, options)
	                .then(ensureConsistency);
	        },
	
	        // gets the settings for a specific tier (ie. g2m or g2mFree)
	        tierSettings: function (tier, headers, options) {
	            // load the settings and pass them through a consitency check fn
	            var locale = language.get() ? language.get().replace('-', '_') : 'en'; // API expects underscores instead of dashes
	            return cors.getSecure(webUrls.get('meetingSvcUrl') + '/rest/2/settings?tier=' + tier + '&locale=' + locale, null, headers, options)
	                .then(ensureConsistency);
	        },
	
	        updateSettings: function(data, headers, options) {
	            return cors.putSecure(webUrls.get('meetingSvcUrl') + '/rest/2/settings', data, headers, options);
	        },
	
	        deleteLogo: function(headers, options) {
	            return cors.delSecure(webUrls.get('meetingSvcUrl') + '/rest/2/settings/logo', headers, options);
	        },
	
	        getFilteredCoorganizers: function(key, query) {
	
	            /*
	             *  encode the entered co-org search query
	             *  special handling for the apostrophe according to Spring expression langage
	             *  apostrophe needs to be escaped with another apostrophe
	             *  and both need to be encoded
	            */
	            query = window.encodeURIComponent(query).replace(/[']/g, function(c) {
	                return '%27%27';
	            });
	            return user.me()
	            .then(function(me) {
	                // Send filter query parameter as a part of url only. Do not send it as a separate query parameters
	                // in ajax request, otherwise it will break the proxy mechanism for IE.
	                return cors.getSecure(webUrls.get('meetingSvcUrl') + '/rest/2/accounts/' + me.accountKey +
	                  '/users?filter=(((email matches \'(?i).*' + query + '.*\')or(firstName matches \'(?i).*' + query +
	                  '.*\')or(lastName matches \'(?i).*' + query + '.*\'))' + key + ')');
	            });
	        },
	
	        coorganizers: function(query, excludes, headers, options) {
	            var excludeQuery = excludes ? '&excludes=' + excludes.join(',') : '';
	            return cors.getSecure(webUrls.get('meetingSvcUrl') + '/rest/2/coorganizers/?query=' + query + excludeQuery, null, headers, options);
	        },
	
	        /**
	         * Get labs features for the user
	         */
	        getLabsFeatures: function(headers, options) {
	            return cors.getSecure(webUrls.get('meetingSvcUrl') + '/rest/2/labs/features', null, headers, options);
	        },
	
	        /**
	        * get the status of the downstream dependencies, this can be used to decide to make specific calls
	        */
	        getServiceStatus: function () {
	            return $.ajax({
	                url: '/functionalStatus',
	                type: 'GET',
	                cache: false,
	                dataType: 'json'
	            });
	        }
	    };
	
	    module.exports = user;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 13 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_13__;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function(require, exports, module) {
		var _ = __webpack_require__(5);
	
		/**
		* Available Countries Filter
		* filter the listOfCounties by the available countries.
		* This is to prevent any list of countries (selected, prefered, etc)
		* to contain countries that are not available in the account
		*
		* @param {Array} listOfCountries - List of county codes to be filtered
		* @param {Array} availableCountries - List of countries that can exist in the result
		* @result {Array} - a filter list of countires
		*
		*/
		function filter(listOfCountries, availableCountries) {
		    return _.intersection(listOfCountries, availableCountries);
		}
	
		module.exports = filter;
	
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function(require, exports, module) {
	    var ko = __webpack_require__(4);
	    var cors = __webpack_require__(8);
	    var ajaxHelper = __webpack_require__(1);
	    var userApi = __webpack_require__(12);
	    var webUrls = __webpack_require__(10);
	    var $ = __webpack_require__(2);
	
	    var guardCall = function (success) {
	        return userApi.getServiceStatus().then(function (status) {
	            if (!status['extadmin-service'].up) {
	                return $.Deferred().reject({}).promise();
	            }
	
	            if (success) {
	                return success();
	            }
	        });
	    };
	
	    var self = this;
	
	    /**
	     * Module for connecting into External Admin API, use a proxy till Ext Admin API supports CORS
	     */
	    var extadmin = {
	
	        getLicense: function() {
	            return guardCall(function () {
	                var url = webUrls.get('adminRestUrl') + '/licenses?filter=products="G2M"';
	                return cors.getSecure(url);
	            });
	        },
	
	        addOrganizers: function(accountKey, data) {
	            if (data.users.length < 1) {
	                return;
	            }
	            return guardCall(function () {
	                var url = webUrls.get('adminRestUrl') + '/accounts/' + accountKey + '/users?allOrNothing=false';
	                return cors.postSecure(url, data);
	            });
	        },
	
	        addAdmins: function(accountKey, data) {
	            if (data.users.length < 1) {
	                return;
	            }
	            return guardCall(function () {
	                var url = webUrls.get('adminRestUrl') + '/accounts/' + accountKey + '/users?allOrNothing=false';
	                return cors.postSecure(url, data);
	            });
	        },
	
	        getProductSettings: function (accountKey, tier) {
	            return guardCall(function () {
	                var url = webUrls.get('adminRestUrl') + '/accounts/' + accountKey + '/products/' + tier + '/settings';
	                return cors.getSecure(url, null)
	                    .then(function (resp) {
	                        return resp;
	                    });
	            });
	        },
	
	        getDefaultTemplate: function (accountKey) {
	            return guardCall(function () {
	                var url = webUrls.get('adminRestUrl') + '/accounts/' + accountKey + '/profiles/default';
	                return cors.getSecure(url, null)
	                    .then(function (resp) {
	                        return resp.settings.G2M;
	                    });
	            });
	        },
	
	        getMe: function () {
	            return guardCall(function () {
	                var url = webUrls.get('adminRestUrl') + '/me';
	                return cors.getSecure(url, null)
	                    .then(function (resp) {
	                        return resp;
	                    });
	            });
	        },
	
	        getAllowedTFCountries: function (accountKey, tier) {
	            return guardCall(function () {
	                var url = webUrls.get('adminRestUrl') + '/accounts/' +
	                    accountKey + '/products/' + tier + '/audio/countries/tollfree';
	                return cors.getSecure(url, null);
	            });
	        },
	
	        updateProductSettings: function (accountKey, tier, data) {
	            return guardCall(function () {
	                var url = webUrls.get('adminRestUrl') + '/accounts/' +
	                    accountKey + '/profiles/default/products/' + tier + '/settings';
	                return cors.putSecure(url, data);
	            });
	        }
	
	    };
	
	    module.exports = extadmin;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function(require, exports, module) {
	    var cors = __webpack_require__(8);
	    var userApi = __webpack_require__(12);
	    var webUrls = __webpack_require__(10);
	    var $ = __webpack_require__(2);
	
	    var guardCall = function (success) {
	        return userApi.getServiceStatus().then(function (status) {
	            if (!status['gotomeetme-service'].up) {
	                return $.Deferred().reject({}).promise();
	            }
	
	            if (success) {
	                return success();
	            }
	        });
	    };
	
	    // API calls handling gotomeet.me specifics
	    // https://confluence.ops.expertcity.com/display/collaboration/Profiles+and+Meeting+Room+APIs
	    var gotomeet = {
	
	        // create a unique gotomeet.me url
	        create: function(data, headers, options) {
	            return guardCall(function () {
	                return cors.postSecure(webUrls.get('meetingSvcUrl') + '/rest/2/profiles', data, headers, options);
	            });
	        },
	
	        get: function(name, headers, options) {
	            return guardCall(function () {
	                return cors.get(webUrls.get('meetingSvcUrl') + '/rest/2/search/profiles/' + name, null, headers, options);
	            });
	        },
	
	        getByUserKey: function(headers, options) {
	            return guardCall(function () {
	                return cors.getSecure(webUrls.get('meetingSvcUrl') + '/rest/2/search/profile/', null, headers, options);
	            });
	        },
	
	        // Use updateV2() for profile info update
	        update: function(name, data, headers, options) {
	            return guardCall(function () {
	                return cors.putSecure(webUrls.get('meetingSvcUrl') + '/rest/2/profiles/' + name, data, headers, options);
	            });
	        },
	
	        // Calls G2MM layer directly, bypassing meeting-services
	        // Use only for profile info updates.
	        // Does not support meeting info updates.
	        updateProfileInfo: function(profileId, data, headers, options) {
	            return guardCall(function () {
	                return cors.putSecure(webUrls.get('gotoMeetMeApiUrl') + '/api/profiles/' + profileId, data, headers, options);
	            });
	        },
	
	        createMeetingRoom: function(profileId, meetingId, headers, options) {
	            var roomUrl = webUrls.get('gotoMeetMeApiUrl') + '/api/profiles/' + profileId + '/rooms';
	            var data = {meetingId: meetingId};
	            return guardCall(function () {
	                return cors.postSecure(roomUrl, data, headers, options);
	            });
	        },
	
	        getRoomByMeetingId: function(meetingId, headers, options) {
	            return guardCall(function () {
	                return cors.getSecure(webUrls.get('gotoMeetMeApiUrl') + '/api/room?meetingId=' + meetingId, null, headers, options);
	            });
	        }
	
	    };
	
	    module.exports = gotomeet;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function(require, exports, module) {
	    var cors = __webpack_require__(8);
	    var webUrls = __webpack_require__(10);
	
	    /**
	     * Perform a post request for logging services
	     *
	     * @param url <logging service url>
	     * @param data
	     * @returns {*}
	     */
	    var logging = {
	
	        // create entry on logging services
	        create: function(data) {
	            return cors.post(webUrls.get('loggingSvcUrl'), data);
	        }
	    };
	
	    module.exports = logging;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function(require, exports, module) {
	    var http = __webpack_require__(3);
	    var cors = __webpack_require__(8);
	    var _ = __webpack_require__(5);
	    var time = __webpack_require__(19);
	    var userApi = __webpack_require__(12);
	    var ko = __webpack_require__(4);
	    var moment = __webpack_require__(13);
	    var webUrls = __webpack_require__(10);
	
	    /*
	     * Module for connecting into G2M Meetings API
	     * @type {{forOrganizer: forOrganizer, scheduled: scheduled, organizerSettings: organizerSettings}}
	     */
	    var meetings = {
	
	        /*
	         * End Meeting
	         * End Meeting API - ends a meeting session:
	         * determines if the meeting exists and if it is in session (anonymous call)
	         * ends screen sharing session (with delegation token -> screensharing)
	         * deletes the video session created when the session was started (the new call based on the meetingId)
	         */
	        end: function(meetingId, delegationToken, headers, options) {
	            var header = headers || {};
	            header.Authorization = 'Delegation ' + delegationToken;
	            
	            return cors.del(webUrls.get('meetingSvcUrl') + '/rest/2/meetings/' + meetingId + '/session', header, options);
	        },
	
	        currentSession: function(headers, options) {
	            return cors.getSecure(webUrls.get('meetingSvcUrl') + '/rest/2/currentSession', null, headers, options);
	        },
	
	        // TODO Rename to launcherHostToken
	        launcherToken: function(meetingId, code, redirectUri, sessionTrackingId, headers, options) {
	            var sessionParam = sessionTrackingId ? '&sessionTrackingId=' + sessionTrackingId : '';
	            var params = '?meetingId=' + meetingId + sessionParam;
	            return cors.getSecure(webUrls.get('meetingSvcUrl') + '/rest/2/meetings/host/launchtoken' + params, null, headers, options);
	        },
	
	        launcherJoinToken: function(meetingId, code, authToken, redirectUri, sessionId, headers, options) {
	
	            var params = [];
	
	            if (code) {
	                params.push('handoverToken=' + code);
	            }
	
	            if (authToken) {
	                params.push('_authorization=Bearer ' + authToken);
	            }
	
	            if (sessionId) {
	                params.push('sessionTrackingId=' + sessionId);
	            }
	
	            params = params.length > 0 ? '?' + params.join('&') : '';
	
	            return cors.post(webUrls.get('meetingSvcUrl') + '/rest/2/meetings/' + meetingId + '/launchtoken' + params, null, headers, options);
	        },
	
	        create: function(data, headers, options) {
	            return cors.postSecure(webUrls.get('meetingSvcUrl') + '/rest/2/meetings', data, headers, options);
	        },
	
	        /*
	         * Delete Meeting
	         * Delete a meeting by its meetingId
	         */
	        del: function(meetingId, headers, options) {
	            return cors.delSecure(webUrls.get('meetingSvcUrl') + '/meeting/rest/2/meetings/' + meetingId, headers, options);
	        },
	
	        /*
	         * Get Meetings by meeting id
	         * Get Meeting API provides all necessary information about a meeting t
	         * that allows an attendee to join it. It also provides extra credentials such
	         * as organizerToken and delegationToken for an authenticated organizer.
	         */
	        byId: function(meetingId, headers, options) {
	            return userApi.settings(headers, options).then(function(setting) {
	                if (setting.isCoorganizerFeatureEnabled) {
	                    return cors.getSecure(webUrls.get('meetingSvcUrl') + '/rest/2/meetings/' + meetingId +
	                    '?includeCoorganizers=true', null, headers, options);
	                } else if (!setting.isCoorganizerFeatureEnabled) {
	                    return cors.getSecure(webUrls.get('meetingSvcUrl') + '/rest/2/meetings/' + meetingId, null, headers, options);
	                }
	            });
	        },
	
	        byIdNoAuth: function(meetingId, includeFeatures, aHeaders, options) {
	            var url = webUrls.get('meetingSvcUrl') + '/meeting/rest/2/meetings/' + meetingId;
	            var query = includeFeatures ? {includeFeatures: true} : {};
	            var headers = aHeaders || {};
	
	            return cors.get(url, query, headers, options);
	        },
	
	        /*
	         * Get meeting by meeting id and extract relevant data
	         */
	        byIdFormatted: function(meetingId, headers, options) {
	            return meetings.byId(meetingId, headers, options)
	                .then(function(meeting) {
	                    if (meeting.meetingType === 'scheduled') {
	                        meeting.timeStrings = time.getMeetingTimeStrings(meeting.scheduledStartTime,
	                            meeting.scheduledEndTime);
	                    } else {
	                        meeting.timeStrings = time.getMeetingTimeStrings(moment().endOf('hour').add('minute', 1),
	                            moment().endOf('hour').add('minute', 1).add('hours', 1));
	                    }
	                    return meeting;
	                });
	        },
	
	        /*
	         * Update meeting settings
	         */
	        updateSettings: function(meetingId, data, headers, options) {
	            return cors.putSecure(webUrls.get('meetingSvcUrl') + '/rest/2/meetings/' + meetingId, data, headers, options);
	        },
	
	        updateAccountSettings: function(accountKey, data, headers, options) {
	            return cors.putSecure(webUrls.get('meetingSvcUrl') + '/rest/2/accounts/' + accountKey + '/settings', data, headers, options);
	        },
	
	        removeAllCoorganizers: function(meetingId, headers, options) {
	            return cors.delSecure(webUrls.get('meetingSvcUrl') + '/meeting/rest/2/meetings/' + meetingId + '/coorganizers', headers, options);
	        },
	
	        /*
	         * Get Meetings For An Organizer
	         * Get Meetings API provides the entire list of meetings for an organizer.
	         */
	        forOrganizer: function(params, headers, options) {
	            var requestUrl = webUrls.get('meetingSvcUrl') + '/rest/2/meetings';
	            if (!params) {
	                params = {};
	            } else if (params && params instanceof Object !== true) {
	                throw new Error('API call \"forOrganizer\" expects parameters to be provided in an object form');
	            }
	            return userApi.settings(headers, options)
	                .then(function(setting) {
	                    if (setting.isCoorganizerFeatureEnabled) {
	                        params.includeCoorganizers = true;
	                    }
	                    return cors.getSecure(requestUrl, params, headers, options);
	                });
	        },
	
	        forAccount: function(params, headers, options) {
	            return userApi.me(headers, options)
	                .then(function(user) {
	                    var requestUrl = webUrls.get('meetingSvcUrl') + '/rest/2/accounts/' + user.accountKey + '/meetings';
	                    if (!params) {
	                        params = {};
	                    } else if (params && params instanceof Object !== true) {
	                        throw new Error('API call \"forAccount\" expects parameters to be provided in an object form');
	                    }
	                    return cors.getSecure(requestUrl, params, headers, options);
	                });
	        },
	
	        /*
	         * Get Meetings For An Organizer and Extract relevant data
	         */
	        forOrganizerFormatted: function(headers, options) {
	            return meetings.forOrganizer({includePast: true}, headers, options)
	                .then(function(data) {
	                    _.map(data, function(meeting) {
	                        //If not a recurring meeting, update meeting time format
	                        if (meeting.meetingType === 'scheduled') {
	                            meeting.timeStrings = time.getMeetingTimeStrings(meeting.scheduledStartTime,
	                                meeting.scheduledEndTime);
	                        }
	                    });
	                    return data;
	                });
	        },
	
	        /*
	         * Get Meeting History For An Organizer
	         * The organizer is identified by the auth token provided.
	         *
	         * @param params - Object of optional parameters
	         * @param params.page - Page index (zero-indexed.  default: 0)
	         * @param params.size - Number of meeting to return
	         * @param params.from - Timestamp (epoch time) indicating the start of the interval (default: to beginning of
	         *     epoch)
	         * @param params.to - Timestamp (epoch time) indicating the end of the interval (default: current time) |
	         *     number
	         * @param params.sort -  list of session fields
	         * (sessionId,meetingId,accountKey,organizerKey,startTime,endTime,updateTime,expirationTime)
	         * used to sort the sessions result set (if not specified the default sorting would be on the field startTime).
	         * @param params.order - [SOA:asc, desc] (if missing ascending is implicit)
	         *
	         * @return {{}} - History for organizer
	         */
	        historyForOrganizer: function(params, headers, options) {
	
	            if (!params) {
	                params = {};
	            } else if (params && params instanceof Object !== true) {
	                throw new Error('API call \"historyForOrganizer\" expects parameters to be provided in an object form');
	            }
	
	            //Size and From get set to default, to execute bare request with max allowed values
	            params.size = (typeof params.size === 'undefined') ? '200' : params.size;
	            params.from = (typeof params.from === 'undefined') ? '0' : params.from;
	            var requestUrl = webUrls.get('meetingSvcUrl') + '/rest/2/history/sessions' + '?size=' + params.size +
	                '&from=' + params.from;
	
	            //Removed items required for bare request
	            params = _.omit(params, function(val, key) {
	                return key === 'size' || key === 'from';
	            });
	
	            //Append remaining parameters
	            _.forEach(params, function(val, key) {
	                requestUrl = requestUrl + '&' + key + '=' + val;
	            });
	
	            return cors.getSecure(requestUrl, null, headers, options);
	        },
	
	        /*
	         *  Format meeting history
	         */
	        historyForOrganizerFormatted: function(params, headers, options) {
	            return meetings.historyForOrganizer(params, headers, options)
	                .then(function(data) {
	                    _.map(data.sessions, function(meeting) {
	                        meeting.timeStrings = time.getMeetingTimeStrings(meeting.startTime, meeting.endTime);
	                    });
	                    return data;
	                });
	        },
	
	        usage: function(params, headers, options) {
	            var requestUrl = webUrls.get('meetingSvcUrl') + '/rest/2/usage';
	            return userApi.settings(headers, options)
	                .then(function(setting) {
	                    if (setting.isCoorganizerFeatureEnabled) {
	                        params.includeCoorganizers = true;
	                    }
	                    return cors.getSecure(requestUrl, params, headers, options);
	                });
	        },
	
	        /*
	         * Get Scheduled Meetings For Certain Users
	         * Get Scheduled Meetings for certain users, using a list of userKeys. Max # userKeys is 40.
	         */
	        scheduled: function() {
	
	        },
	
	        /*
	         * Get Meeting History For An Organizer
	         * The organizer is identified by the auth token provided.
	         */
	        organizerSettings: function() {
	
	        },
	
	        account: function(headers, options) {
	            return userApi.me(headers, options)
	                .then(function(me) {
	                    return cors.getSecure(webUrls.get('meetingSvcUrl') + '/rest/2/accounts/' + me.accountKey, null, headers, options);
	                });
	        },
	
	        acceptTos: function(headers, options) {
	            return userApi.me(headers, options)
	                .then(function(me) {
	                    var data = {
	                        'termsofserviceaccepteduseremail': me.email,
	                        'termsofserviceacceptedtimestamp': new Date().getTime()
	                    };
	
	                    return cors.putSecure(webUrls.get('meetingSvcUrl') + '/rest/2/accounts/' + me.accountKey, data, headers, options);
	                });
	        },
	
	        getInvitation: function (meetingId, queryParams, headers, options) {
	            // Override incorrect content-type and data-type
	            var opt = options || {};
	            opt.contentType = null;
	            opt.dataType = null;
	            return cors.get(
	                webUrls.get('invitationSvcUrl') + '/' + meetingId,
	                queryParams,
	                headers,
	                opt
	            );
	        }
	    };
	
	    module.exports = meetings;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function(require, exports, module) {
	    var moment = __webpack_require__(13);
	
	    /*
	     * Extracts timezone abbreviation form an ISO date string
	     *
	     * @param date as an ISO date string
	     * @return String timezone as a string
	     */
	    function getTimeZone(date) {
	        var dateString = moment(date).toDate().toString();
	        var leftIndex = dateString.indexOf('(') + 1;
	        var rightIndex = dateString.indexOf(')');
	        return dateString.substring(leftIndex, rightIndex);
	    }
	
	    /*
	     * Extract Meeting duration from two ISO date strings
	     *
	     * @param startTime as an ISO date string
	     * @param endTime as an ISO date string
	     *
	     * @return string representation for number of minutes
	     */
	    function getMeetingDuration(startTime, endTime) {
	        var durationInMiliseconds = moment(endTime).diff(startTime);
	        var durationInMinutes = Math.round(durationInMiliseconds / (1000 * 60));
	        return durationInMinutes.toString();
	    }
	
	    var time = {
	        /*
	         * Accepts meeting start and end times, and extracts strings needed for front end implementation
	         *
	         * @param startTime ISO Date String
	         * @param endTime ISO Date String
	         * @returns {{}} Formatted Meeting Date Strings
	         */
	        getMeetingTimeStrings: function(startTime, endTime) {
	            var startDate = moment(startTime);
	            var endDate = moment(endTime);
	            if (!startDate.isValid() || !endDate.isValid()) {
	                throw new TypeError('Expected ISO standard date');
	            }
	            var meeting = {};
	            meeting.meetingDate = startDate.format('ddd, MMM D');
	            meeting.meetingStartTime = startDate.format('h:mm');
	            meeting.meetingStartPeriod = startDate.format('A');
	            meeting.meetingFromTime = startDate.format('h:mm');
	            meeting.meetingEndTime = endDate.format('h:mm');
	            meeting.meetingEndPeriod = endDate.format('A');
	            meeting.meetingToTime = endDate.format('h:mm A');
	            meeting.meetingTimeZone = getTimeZone(startTime);
	            meeting.meetingDuration = getMeetingDuration(startTime, endTime);
	            meeting.meetingStartYear = startDate.format('YYYY');
	            meeting.meetingEndYear = startDate.format('YYYY');
	
	            return meeting;
	        }
	    };
	
	    module.exports = time;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function(require, exports, module) {
	    var cors = __webpack_require__(8);
	    var webUrls = __webpack_require__(10);
	
	    var numbers = {
	
	        /*
	         * Get all the phone numbers for a meeting by countries
	         * @param meetingId - 9-digit meetingId
	         */
	        alternates: function(meetingId, headers, options) {
	            return cors.get(webUrls.get('meetingSvcUrl') + '/rest/2/meetings/' + meetingId + '/audio?alternate=true', null, headers, options);
	        },
	
	        /*
	         * Get all the primary phone numbers for a meeting by countries
	         * @param meetingId - 9-digit meetingId
	         */
	        primaries: function(meetingId, headers, options) {
	            return cors.get(webUrls.get('meetingSvcUrl') + '/rest/2/meetings/' + meetingId + '/audio', null, headers, options);
	        },
	
	        /*
	         * GET phone number changes
	         * @params meetingId (optional)
	         *
	         * get array of phone number changes
	         */
	        phoneNumberChanges: function(headers, options) {
	            return cors.getSecure(webUrls.get('meetingSvcUrl') + '/rest/2/phonenumberchanges', null, headers, options);
	        },
	
	        /*
	         * Update phone number changes
	         * @params meetingId
	         *
	         * PUT request is made to update based on meetingId
	         */
	        updatePhoneNumberChanges: function(meetingId, headers, options) {
	            return cors.putSecure(webUrls.get('meetingSvcUrl') + '/rest/phonenumberchanges/' + meetingId, null, headers, options);
	        }
	    };
	
	    module.exports = numbers;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function(require, exports, module) {
	    var cors = __webpack_require__(8);
	    var webUrls = __webpack_require__(10);
	
	    /*
	     *  G2M CLOUD BASED RECORDING API
	     */
	    var isValidSessionId = function(sessionId) {
	        if (!sessionId) {
	            return false;
	        }
	        return true;
	    };
	    var INVALID_SESSION_ID = 'Invalid sessionId!';
	
	
	    var recordings = {
	        /*
	        * Start the recording of a running session/meeting
	        * @param sessionId - meeting's unique sessionId (not the 9-digit meetingId)
	        */
	        startRecording: function(sessionId, headers, options) {
	            if (isValidSessionId(sessionId)) {
	                return cors.postSecure(webUrls.get('meetingSvcUrl') + '/rest/sessions/' + sessionId + '/recording/start', null, headers, options);
	            }
	            throw new Error(INVALID_SESSION_ID);
	        },
	        /*
	        * Pause a started recording of a running session/meeting
	        * @param sessionId - unique sessionId of the meeting (not the 9-digit meetingId)
	        */
	        pauseRecording: function(sessionId, headers, options) {
	            if (isValidSessionId(sessionId)) {
	                return cors.postSecure(webUrls.get('meetingSvcUrl') + '/rest/sessions/' + sessionId + '/recording/pause', null, headers, options);
	            }
	            throw new Error(INVALID_SESSION_ID);
	        },
	        /*
	        * Resume a paused recording of a running session/meeting
	        * @param sessionId - unique sessionId of the meeting (not the 9-digit meetingId)
	        */
	        resumeRecording: function(sessionId, headers, options) {
	            if (isValidSessionId(sessionId)) {
	                return cors.postSecure(webUrls.get('meetingSvcUrl') + '/rest/sessions/' + sessionId + '/recording/resume', null, headers, options);
	            }
	            throw new Error(INVALID_SESSION_ID);
	        },
	        /*
	         * Delete a stored recording from cloud storage
	         * @param sessionId - unique sessionId of the meeting (not the 9-digit meetingId)
	         */
	        deleteRecording: function(sessionId, headers, options) {
	            if (isValidSessionId(sessionId)) {
	                return cors.delSecure(webUrls.get('meetingSvcUrl') + '/rest/sessions/' + sessionId + '/recording', headers, options);
	            }
	            throw new Error(INVALID_SESSION_ID);
	        },
	        /*
	         * Has a user at least one recording
	         */
	        hasRecordings: function(headers, options) {
	            return cors.getSecure(webUrls.get('meetingSvcUrl') + '/rest/2/me/hasRecordings', null, headers, options);
	        },
	        /*
	         * Create an id that points to a recording and can be used to create shareable links
	         * @param sessionId - sessionId to create the share for
	         * @param validity - an ISO 8601 Duration string (ie. P2DT3H4M is 2 days 3 hrs and 4 min)
	         */
	        getShareId: function(sessionId, validity, headers, options) {
	            if (isValidSessionId(sessionId)) {
	                return cors.postSecure(webUrls.get('meetingSvcUrl') + '/rest/shareables', {sessionId: sessionId, validity: validity}, headers, options);
	            }
	            throw new Error(INVALID_SESSION_ID);
	        },
	        getTranscriptShareId: function (accountKey, userKey, sessionId, headers, options) {
	            return cors.postSecure(webUrls.get('transcriptsCluster') + '/v1/sharing/share', { accountKey: accountKey, userKey: userKey, sessionKey: sessionId }, headers, options);
	        },
	        /*
	         * Get data for a specific recording using a already created shareId. This call is not secured by an auth header
	         * because it need to be callable by an unauthorized user in case a recording was shared outside the G2M realm.
	         */
	        getSharedRecording: function(shareId, headers, options) {
	            return cors.get(webUrls.get('meetingSvcUrl') + '/rest/shareables/' + shareId, null, headers, options);
	        },
	        /**
	         * Gets a shared session (recording) by share key.
	         */
	        getSharedSession: function(shareKey, headers, options) {
	          return cors.get(webUrls.get('transcriptsCluster') + '/v2/products/g2m/' + shareKey + '/session', headers, options);
	        },
	        /**
	         * Gets a share from a session id.
	         */
	        getShareFromSession: function(sessionKey, accountKey, userKey, headers, options) {
	          return cors.getSecure(webUrls.get('transcriptsCluster') + '/v1/sharing/session/' + sessionKey, {
	            accountKey: accountKey,
	            userKey: userKey
	          }, headers, options);
	        },
	        /**
	         * Creates a shared session. Can also be used to toggle sharing on/off.
	         */
	        createShare: function(sessionKey, accountKey, userKey, scope, headers, options) {
	          return cors.postSecure(webUrls.get('transcriptsCluster') + '/v1/sharing/share', {
	            accountKey: accountKey,
	            userKey: userKey,
	            sessionKey: sessionKey,
	            scope: scope
	          }, headers, options);
	        }
	    };
	
	    module.exports = recordings;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ })
/******/ ])
});
;
//# sourceMappingURL=api-access.js.map;
